module.exports = __webpack_public_path__ + "static/media/colchagua.e26f5afd.jpg";